import NannyJobsDirectories from 'pages/nanny-jobs'
export default NannyJobsDirectories
